@if (vm$ | async; as vm) { @if (vm.user) {
<ion-avatar class="ion-margin-vertical">
  <img
    [src]="vm.user.photoURL || 'assets/images/user-profile-anon.svg'"
    [alt]="vm.user.displayName"
  />
</ion-avatar>
<ion-label class="name">{{ vm.user.displayName }}</ion-label>
<ion-label class="username">{{ vm.user.email }}</ion-label>
<ion-menu-toggle auto-hide="true">
  <ion-button (click)="logout()" expand="block" fill="clear" color="light">
    Log Out
  </ion-button>
</ion-menu-toggle>
} }
